<template>

</template>

<script>

	import moment from 'moment';
	import { mapState } from 'vuex';


	export default {
		name: 'ProximityReport',
		data() {
			return {
				open_proximity_panel: false,
				rec: null,
				date_start: this.$store.state.start_date,
				date_end: this.$datetime.date(),
				alert: [],
				range: null,
				columns: {
					individual: [
						{
							label: "Name",
							field: "worker",
							numeric: false,
							html: false
						},
						{
							label: "Contact Frequency",
							field: "count",
							numeric: true,
							html: false
						},
						{
							label: "Total Contact Duration",
							field: "duration",
							numeric: true,
							html: false
						},
					],
					general: [
						{
							label: 'Asset',
							field: 'worker_a',
							numeric: false,
							html: false
						},
						{
							label: 'Encountered Asset',
							field: 'worker_b',
							numeric: false,
							html: false
						},
						{
							label: 'Contact Time',
							field: 'clock',
							numeric: false,
							html: false
						},
						{
							label: 'Contact Duration',
							field: 'duration_min',
							numeric: true,
							html: false
						}
					]
				}
			}
		},
		computed: {
			...mapState([
				'workers',
				'proximity',
				'start_date',
				'day'
			]),
		},
		watch: {
			mode() {
				if (this.rec) this.individualProximityReport(this.rec);
				else this.generalProximityReport();
			},
			day() {

			},
			'proximity.alert': function() {
				if (this.rec) this.individualProximityReport(this.rec);
				else this.generalProximityReport();
			},
			date_start() {
				if (this.rec) this.individualProximityReport(this.rec);
				else this.generalProximityReport();
			},
			date_end() {
				if (this.rec) this.individualProximityReport(this.rec);
				else this.generalProximityReport();
			}
		},
		mounted() {
			// console.log(this.date_start);
		},
		methods: {
			proximityReport(item) {
				this.open_proximity_panel = false;


				this.alert = {};
				if (this.rec == item) { // deselect
					this.rec = null;
					this.generalProximityReport();
				}
				else this.individualProximityReport(item);

				setTimeout(() => {
					this.open_proximity_panel = true;
				}, 400)

			},
			getDateRange() {

				let start_date = new Date(this.start_date);

				start_date = start_date.getUTCFullYear()+"-"+(start_date.getMonth() + 1)+"-"+start_date.getDate();

				let date_start = this.date_start ? this.date_start : start_date ;
				let date_end =  this.date_end ? this.date_end : this.$datetime.date();


				let a = moment(start_date);
				let b = moment(date_start);
				let day1 = Math.max(1, b.diff(a, 'days') + 1);

				a = moment(start_date);
				b = moment(date_end);
				let day2 = Math.max(day1, b.diff(a, 'days') + 1);

				return this.$finder.range(day1, day2);

			},
			toggleDateRange(n) {
				this.range = (n == this.range ? this.range = null : n);
				this.setDateRange(this.range);
			},
			setDateRange(n) {
				if (n == null) {
					this.date_end = this.$datetime.date();
					this.date_start = this.start_date;
				}
				else {
					this.date_end = this.$datetime.convertToUTC(this.$datetime.date());
					this.date_start = this.$datetime.convertToUTC(this.$datetime.date(this.time, this.day - n));
				}
				this.range = n;
			},
			generalProximityReport() {
				let range = this.getDateRange();
				let result = this.$finder.all({day: range} ,this.proximity.alert);
				let alert = [];
				for (let i in result) {
					//if (result[i].duration < 30) continue;
					result[i]['worker_a'] = this.$worker.getName(result[i].workers[0]);
					result[i]['worker_b'] = this.$worker.getName(result[i].workers[1]);
					result[i].duration_min = Math.ceil(result[i].duration/60);
					alert.push(result[i]);
				}
				this.alert = alert;//Object.keys(result).map((key) => result[key]);

			},
			individualProximityReport(item) {
				this.rec = item;

				let range = this.getDateRange();

				// let start_day = this.
				let alerts = this.$finder.all({'workers': [item.id], day: range} ,this.proximity.alert);
				let result = {};
				for (let i in alerts) {
					let alert = alerts[i];
					let worker_id = alert.workers.filter(function(value) { return value != item.id });
					worker_id = worker_id[0];
					if (result[worker_id] == undefined) result[worker_id] = {count: 0, duration: 0, worker_id: worker_id, worker: this.$worker.getName(worker_id)};
					result[worker_id].count++
					result[worker_id].duration += alert.duration;

				}
				for (let i in result) result[i].duration = Math.ceil(result[i].duration / 60);
				this.alert = Object.keys(result).map((key) => result[key]);
			}
		}
	}
</script>

<style scoped lang="scss" rel="stylesheet/scss">

</style>
